import axios from 'axios'
const baseUrl = '/api/targetlevels'

const getAll = async oauthToken => {
  const response = await axios.get(`${baseUrl}/${oauthToken}`)
  return response.data
}

const getByNationalTeam = async (oauthToken, nationalTeamId) => {
  const response = await axios.get(`${baseUrl}/${oauthToken}/${nationalTeamId}`)
  return response.data
}

const update = async (oauthToken, id, targetLevel) => {
  const response = await axios.put(
    `${baseUrl}/${oauthToken}/${id}`,
    targetLevel
  )
  return response.data
}

const create = async (oauthToken, targetLevel) => {
  const response = await axios.post(`${baseUrl}/${oauthToken}`, targetLevel)
  return response.data
}

const seed = async oauthToken => {
  const response = await axios.post(`${baseUrl}/${oauthToken}/seed`)
  return response.data
}

export default { getAll, getByNationalTeam, update, create, seed }
